import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosCloseCircleOutline, IoMdAdd } from "react-icons/io";
import { GiConfirmed } from "react-icons/gi";

const AddCourseModal = ({
  isOpen,
  onClose,
  courseName = "",
  onChange,
  onConfirm,
  loading = false,
  errors = {},
}) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="absolute inset-0 bg-black/50" onClick={onClose} />

          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            className="relative bg-white dark:bg-[#0b1220] text-black dark:text-white rounded-2xl shadow-lg w-[360px] p-6 max-h-[calc(100dvh-2rem)] overflow-y-auto max-w-full"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Confirm add course"
          >
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500"
              onClick={onClose}
              aria-label="Close"
            >
              <IoIosCloseCircleOutline size={24} />
            </button>

            <div className="flex flex-col items-center gap-3">
              <div className="bg-white dark:bg-[#07102a] p-3 rounded-full shadow-sm -mt-8">
                <IoMdAdd size={34} className="text-[#2264E5]" />
              </div>

              <h4 className="text-lg font-semibold">Confirm Course Creation</h4>
              <p className="text-sm text-gray-500 text-center">
                Choose a name for your custom course before confirming your
                purchase.
              </p>

              <div className="w-full mt-2">
                <label htmlFor="courseName" className="text-sm mb-1 block">
                  Course Name
                </label>
                <input
                  id="courseName"
                  name="courseName"
                  value={courseName}
                  onChange={(e) => onChange?.(e.target.value)}
                  className="w-full px-3 py-2 rounded-md border border-gray-200 bg-white text-sm"
                  placeholder="e.g. My Custom Course"
                />
                {errors?.courseName && (
                  <div className="text-xs text-red-500 mt-1">
                    {errors.courseName}
                  </div>
                )}
              </div>

              <div className="w-full flex gap-2 mt-3">
                <button
                  onClick={onConfirm}
                  disabled={loading}
                  className={`flex-1 py-2 rounded-md text-white flex items-center justify-center gap-2 ${
                    loading ? "bg-gray-300" : "bg-[#2264E5] hover:bg-blue-600"
                  }`}
                >
                  <GiConfirmed />
                  {loading ? "Confirming..." : "Confirm"}
                </button>

                <button
                  onClick={onClose}
                  className="flex-1 py-2 rounded-md border border-gray-200 text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AddCourseModal;
